// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"23247376","211":"46d5c0c1","403":"64e0f4e7","409":"4749df82"}[chunkId] + ".chunk.js";
};